import { render, staticRenderFns } from "./UIBtnToggle.vue?vue&type=template&id=4c8afbda"
import script from "./UIBtnToggle.vue?vue&type=script&lang=js"
export * from "./UIBtnToggle.vue?vue&type=script&lang=js"
import style0 from "./UIBtnToggle.vue?vue&type=style&index=0&id=4c8afbda&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports